<template>
  <div>
    <slot></slot>

    <Popup
      v-on:switchPopup="switchPopup"
      v-if="downloadPopupIsShowing"
      v-on:closePopup="closeDownloadPopup"
      type="download"
      text
      v-bind:thumbnails="this.thumbnailList"
    >Download images</Popup>
    <Popup
      v-on:switchPopup="switchPopup"
      v-if="sharingPopupIsShowing"
      v-on:closePopup="closeSharingPopup"
      type="sharing"
      text
      v-bind:share_url="this.shareLink"
      :error="errorOnSVGUpload"
    >Share this page</Popup>
    <Backdrop v-if="downloadPopupIsShowing || sharingPopupIsShowing"/>
    <SlimBanner style="width: 80%;"/>
    <VisContainer
      v-for="index in numberOfVisualizations"
      :key="index"
      :generated="true"
      :id="index.toString()"
      v-right-click="onRightClick"
    />
    <Banner />
    <!--v-longpress="detectLongPress"-->
    <!--:data="extractedData"-->
    <ShareButton
      @click.native="openDownloadPopup()"
      text="Download images"
      imgPath="download.svg"
      color="pink"
      type="download"
    />
    <ShareButton
      text="Share this page"
      imgPath="share.svg"
      color="blue"
      @click.native="openSharingPopup()"
      type="share"
    />
  </div>
</template>

<script>
import VisContainer from "./../components/VisContainer.vue";
import Popup from "./../components/Popup.vue";
import ShareButton from "./../components/ShareButton.vue";
import Backdrop from "./../components/layout/Backdrop.vue";
import Banner from "./../components/Banner";
import SlimBanner from "./../components/SlimBanner";
import uuidv4 from "uuid/v4";
import * as SVGMerger from "../providers/svg-merger.js";
import { production, soft_production, domainName, numberOfVisualizations, generateExampleViz } from "../settings.js";
import * as scrollHandler from "../providers/scroll-handler.js";

export default {
  name: "visualization",
  components: {
    VisContainer,
    Popup,
    ShareButton,
    Backdrop,
    Banner,
    SlimBanner
  },
  beforeCreate() {
    const json = this.$store.state.userJSONData;
    if (Object.keys(json).length === 0) {
      // redirect to upload page if no data present
      this.$router.push({ name: "upload" });
    }
  },
  async mounted() {
    this.json = this.$store.state.userJSONData;
    //console.log("json on vizpage", this.json);
    if (Object.keys(this.json).length > 0) {
      // generate uuid for viz for viz
      this.shareLink = await this.getShareLink();
      // attach state watcher that updates uuid and thumbnails on form data change
      this.attachStateWatcherToComponent();
    }
    this.$store.state.analytics.logEvent("vizpage visited");
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  data() {
    return {
      json: null,
      extractedData: null,
      downloadPopupIsShowing: false,
      sharingPopupIsShowing: false,
      uuid: null,
      shareLink: "",
      uploaded: false,
      numberOfVisualizations: numberOfVisualizations,
      thumbnailList: [],
      unsubscribe: null,
      errorOnSVGUpload: false
    };
  },
  methods: {
    
    switchPopup(type) {
      // switch between download and sharing popup
      if (type === "download") {
        this.closeDownloadPopup()
        this.openSharingPopup()
      } else {
        this.closeSharingPopup()
        this.openDownloadPopup()
      }
    },
    attachStateWatcherToComponent() {
      // listens to changes in the userFormData
      this.unsubscribe = this.$store.subscribe(async (mutation, state) => {
        if (this.$store.state.status === "update_finished") {
          //console.log("STATE VIZPAGE", state);
          //console.log("MUTATION VIZPAGE", mutation);
          // recalculate thumbnails and share link
          this.getThumbnails();
          this.shareLink = await this.getShareLink();
        }
      });
    },
    getThumbnails() {
      //console.log("getting new thumbnails");
      this.thumbnailList = [];
      let mergedSVG = SVGMerger.mergeSVGs();
      this.thumbnailList.push(mergedSVG);

      for (let i = 1; i < this.numberOfVisualizations + 1; i++) {
        let reference = SVGMerger.clone("#svg-" + i, false);
        this.thumbnailList.push(reference);
      }
    },
    onRightClick() {
      this.openDownloadPopup();
    },
    /*detectLongPress() {
      this.openDownloadPopup();
    },*/
    getData(obj) {
      this.json = obj;
    },
    openDownloadPopup() {
      if (this.thumbnailList.length === 0) {
        this.getThumbnails();
      }
      this.downloadPopupIsShowing = true;
      scrollHandler.disableBackgroundScrolling();
    },
    async openSharingPopup() {
      this.sharingPopupIsShowing = true;
      if (!this.uploaded) {
        if (production || soft_production || generateExampleViz) {
          this.uploadSVG();
        }
      }
      scrollHandler.disableBackgroundScrolling();
    },
    closeDownloadPopup() {
      this.downloadPopupIsShowing = false;
      scrollHandler.enableBackgroundScrolling();
    },
    closeSharingPopup() {
      this.sharingPopupIsShowing = false;
      scrollHandler.enableBackgroundScrolling();
    },
    async getUUID() {
      this.uuid = (await uuidv4()) + "-" + new Date().getTime();
      return this.uuid;
    },
    async getShareLink() {
      //console.log("getting new sharelink");
      this.uploaded = false;
      this.errorOnSVGUpload = false;
      return domainName + "?share=" + (await this.getUUID());
    },
    async uploadSVG() {
      for (let i = 1; i < this.numberOfVisualizations + 1; i++) {
        let svg = document.getElementById("svg-" + i).outerHTML;

        const base64SvgURI =
          "data:image/svg+xml;utf8," + encodeURIComponent(svg);

      let common_file_name;
        if (generateExampleViz) {
          common_file_name = 'example';
        } else {
          common_file_name = this.uuid;
        }

        // use firebase storage reference
        var fileRef = this.$store.state.storage
          .ref()
          .child("/sharing/" + common_file_name + "-" + i + ".svg");

        var metadata = {
          cacheControl: 'public,max-age=100000'
        }

        try {
          await fileRef.putString(base64SvgURI, "data_url", metadata);
          //console.log("Uploaded a data_url string to " + fileRef);
          this.uploaded = true;
        } catch (err) {
          this.errorOnSVGUpload = true;
          this.uploaded = false;
          console.log("error", err);
        }
      }
    }
  }
};
</script>

<style scoped>
</style>
